import { Flex, xcss } from "@atlaskit/primitives";

import { BoardSvgStatic } from "../../assets/board-svg-static";
import { ProjectSvg, Injections } from "../../assets/project-svg";

import { HeaderArrow } from "./header-arrow";

export const RightHandSidePageProjectDetails = ({
    projectName
}: {
    projectName: string | undefined;
}) => {
    const injections: Injections = {
        additionalObject: HeaderArrow,
        svgBody: BoardSvgStatic
    };

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            xcss={containerStyles}
        >
            <ProjectSvg
                projectName={projectName}
                activeView="board"
                injections={injections}
            />
        </Flex>
    );
};

const containerStyles = xcss({
    height: "100%",
    backgroundColor: "elevation.surface"
});
